// Pure, dependency-free listing-display helpers shared between
// SearchResults.js (dedicated "Оголошення" tab, unchanged) and
// ListingsPreviewGrid.js (new "Все"-tab preview). Extracted verbatim from
// SearchResults.js so the new preview component can reuse them without a
// SearchResults.js <-> ListingsPreviewGrid.js circular import — no
// behavior change versus the previous inline copies.

export const DEFAULT_LISTING_IMG =
  "https://cvanto-photos.s3.us-east-1.amazonaws.com/DefaultAvatar/avatar.png";

const posterThemes = [
  "blue",
  "violet",
  "graphite",
  "green",
  "bronze",
  "wine",
  "ocean",
  "sand",
];

export const getStablePosterTheme = (item, title) => {
  const source = String(item?.listingId || item?.id || title || "search");
  let hash = 0;

  for (let i = 0; i < source.length; i += 1) {
    hash = source.charCodeAt(i) + ((hash << 5) - hash);
  }

  return posterThemes[Math.abs(hash) % posterThemes.length];
};

export const getPosterTitleSizeClass = (title) => {
  const len = String(title || "").trim().length;

  if (len <= 18) return "is-short";
  if (len <= 42) return "is-medium";
  return "is-long";
};

export const getListingThumb = (item) => {
  return (
    item?.mainPhoto ||
    (Array.isArray(item?.photos) && item.photos[0]) ||
    item?.photo ||
    ""
  );
};

export const isWantedListing = (item) => {
  const listingType = String(
    item?.listingType || item?.typeRaw || item?.type || "",
  ).toLowerCase();
  const type = String(item?.type || "").toLowerCase();

  return listingType === "wanted" || type === "wanted";
};

// PACKAGE #11 — reuses the exact same server-derived isSponsored flag
// /api/feed/v2 and /api/search/feed both already compute (raisedUntil >
// now) — no second boost state here, just a single read. Exported so the
// badge-visibility rule is unit-testable without rendering a whole page.
export const shouldShowBoostBadge = (item) => !!item?.isSponsored;

const CURRENCY_SYMBOL_MAP = {
  USD: "$",
  EUR: "€",
  PLN: "zł",
  GBP: "£",

  UAH: "ГРН",
  "₴": "ГРН",
  "грн": "ГРН",
  "ГРН": "ГРН",

  "$": "$",
  "€": "€",
  "zł": "zł",
  "£": "£",
};

export const formatCurrencyLabel = (c) => {
  const raw = c ?? "ГРН";
  const key = String(raw).trim();
  return CURRENCY_SYMBOL_MAP[key] || key;
};
